import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonUtil, MessageService, TablePage } from '@serengeti/serengeti-common';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SchedulerRuleService {

  endPoint: string;
  
  constructor(private messageService: MessageService) {
    this.endPoint = CommonUtil.buildEndPoint(environment.serviceSchedulerEndPoint, 'rule');
  }

	search(filter = '',
		sortItem = 'createdDate', sortOrder = 'asc',
		pageNumber = 0, pageSize = 10): Observable<TablePage> {

		const url = CommonUtil.buildEndPoint(this.endPoint, '/');

		return this.messageService.query(url, new HttpParams()
			.set('keyword', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString())
		).pipe(
			map(res =>  res)
		);
  }
  
  get(id: string): Observable<any> {
    const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

    return this.messageService.query(url);
  }

  save(id: string, rule: any) {
    let url = CommonUtil.buildEndPoint(this.endPoint, '/');

    if (id) {
      url += id + '/';
      return this.messageService.put(url, rule);
    } else {
      return this.messageService.post(url, rule);
    }
  }

  delete(id: string): Observable<void> {
    const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

    return this.messageService.delete(url);
  }
}
